import {Component, EventEmitter, Input, Output, OnChanges, OnInit} from "@angular/core";
import {
    ITCIMarketplaceListing,
    ITCIMarkupEditorContext,
    ITCIUserInfo,
    SERVICE_URLS,
    TCI_MARKETPLACE_LISTING_TYPE,
    TCI_MARKETPLACE_LISTING_VIEW_MODE,
    TCI_MEDIA_DISPLAY_MODE,
    TCI_RATINGS_COMPONENT_MODE
} from "@tci/common";
import {cloneDeep, isEmpty} from "lodash";
import { NgUserService } from "../../ng-shared/ng-services/ng-user.service";
import {MKP_FOOTER_ITEMS} from "../ng-marketplace-v2-listing/boolean-table/listing-bt-evaluations";
import {CheckOverFooterItem} from "../ng-marketplace-v2-listing/boolean-table/listing-bt-footer";

@Component({
    selector: "ng-marketplace-v2-mini-preview",
    templateUrl: "./ng-marketplace-v2-mini-preview.component.html",
    styleUrls: ["./ng-marketplace-v2-mini-preview.component.less"]
})
export class NgMarketplaceV2MiniPreviewComponent implements OnChanges, OnInit {
    @Input() input: ITCIMarketplaceListing;
    @Output() output: EventEmitter<ITCIMarketplaceListing> = new EventEmitter();
    asset: ITCIMarketplaceListing;
    mode = TCI_MARKETPLACE_LISTING_VIEW_MODE.LIST_DETAIL;
    mediaMode = TCI_MEDIA_DISPLAY_MODE.MODE_PROMOTE_VIEW;
    ratingsModeCard = TCI_RATINGS_COMPONENT_MODE.LIST_READ_ONLY;
    LISTING_TYPE = TCI_MARKETPLACE_LISTING_TYPE;
    tags = [];

    // markdown objects
    assetDescription: ITCIMarkupEditorContext;

    // EULA
    eulaUrl = "";
    showEULA = false;

    // User info
    userInfo: ITCIUserInfo;

    constructor (private userService: NgUserService) {

    }

    ngOnInit() {
        this.userService.getUserInfo().subscribe(userInfo => {
            this.userInfo = userInfo;
        });
    }

    ngOnChanges() {
        this.tags = [];
        this.asset = cloneDeep(this.input);
        this.asset.tags.forEach(item => this.tags.push(item.name));
        this.assetDescription = {content: this.asset.description};
        this.getEULA();
    }

    private getEULA() {
        const context = {
            item: MKP_FOOTER_ITEMS.EULA_LINK,
            asset: this.asset,
            mode: TCI_MARKETPLACE_LISTING_VIEW_MODE.PREVIEW_CARD,
            userInfo: this.userInfo
        };
        this.showEULA = CheckOverFooterItem(context).visible;

        if (this.showEULA) {
            this.eulaUrl = this.asset.eulaUrl;
            if (isEmpty(this.eulaUrl)) {
                this.eulaUrl = SERVICE_URLS.MARKETPLACE_EULA;
            }
        }
    }

    createMarketplaceApp() {
        this.output.emit(this.asset);
    }
}
